import { Injectable } from '@angular/core';
import { INode } from "../Configuration/INode";

@Injectable()
export class SelectDialogExportService {
    alert: (message?: string, title?: string) => Promise<void>;
    confirm: (message?: string, node?: Array<Object>, title?: string, details?: string) => Promise<void>;
    subclassList: Array<Object> = [];
    isChecked : boolean = false;
   // subclassList: Array<Map<INode, boolean>>;
}